import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  viewChild,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { HealthUnitService } from '../../../../core/services/health-unit/location/health-unit.service'
import { TariffService } from '../../../../core/services/tariff/tariff/tariff.service'
import { SubtypeExamService } from '../../../../core/services/subtype-exam/subtype-exam/subtype-exam.service'
import { VehicleTypeService } from '../../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { convertCurrency } from '../../../../shared/utils/utils'
import moment from 'moment'

import { ModalSupplierComponent } from '../../../person/supplier/modal_supplier/modal-supplier.component'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { CurrencyInputDirective } from '../../../../shared/directives/currencyInput'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs'
import { MatCheckbox } from '@angular/material/checkbox'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import {DoctorService} from '../../../../core/services/doctor/driver/doctor.service';
import {SupplierService} from '../../../../core/services/person/supplier/supplier.service';
import {ExamTypeService} from '../../../../core/services/exam-type/document-type/exam-type.service';
import {PagedContactTypeResponse} from '../../../../core/models/contact-type.model';
import {
  UnitMeasureTypeService
} from '../../../../core/services/tax-document/tax-document-type/unit-measure-type.service';
import { CommonModule } from '@angular/common';
import {ContextService} from '../../../../core/services/context/context.service';

@Component({
  selector: 'exam-patient-form',
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    MatTabsModule,
    CommonModule,
  ],
  templateUrl: './exam-relation-patient-form.component.html',
  styleUrl: './exam-relation-patient-form.component.scss',
  providers: [
    HealthUnitService,
    DoctorService,
    SubtypeExamService,
    VehicleTypeService,
    provideNgxMask(),
  ],
  standalone: true,
})
export class ExamRelationPatientFormComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private tariffService: TariffService,
    private locationService: HealthUnitService,
    private supplierService: SupplierService,
    private examTypeService: ExamTypeService,
    private serviceSpecificationService: SubtypeExamService,
    private vehicleTypeService: VehicleTypeService,
    private taxDocumentTypeService: UnitMeasureTypeService,
    private specificationService: SubtypeExamService,
    private doctorService: DoctorService,
    private contextService: ContextService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ExamRelationPatientFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {
    if (data && data.edit) {
      this.edit = true
      this.item = data.item
    }
  }

  datepicker = viewChild<MatDatepicker<any>>('birth')
  @Output() responseInsert = new EventEmitter()
  @ViewChild('tabGroup') tabGroup: MatTabGroup | undefined
  @Output() response = new EventEmitter()
  @Input() editItem: any = {}
  subtipoExameEnable: boolean = false
  edit: boolean = false
  item: any = {}
  form: FormGroup = new FormGroup({})
  formParametro: FormGroup = new FormGroup({})
  loading: boolean = false
  listLocation: any[] = []
  listTypeVehicle: any[] = []
  listTipoExames: any[] = []
  doctorsList: any[] = []
  listAlertas: any[] = []
  listUnidadesMedida: any[] = []
  listServiceSpecification: any[] = []
  listSubtipoExames: any[] = []
  listContextos: any[] = []
  parametros: any[] = []
  supplierSelected: any = {}
  editingParametroIndex: number = -1

  ngOnInit(): void {
    this.getDocs()
    this.getLocation()
    this.getListItems()
    this.getTipoExame()
    this.getContextos()
    this.createForm()
    this.createFormParametro()
    this.form.get('examType')?.valueChanges.subscribe(() => {
      this.getSubtipoExame()
      this.subtipoExameEnable = true
    })
    this.getAlertas()
    if (this.edit) {
      this.fillForm(this.item)
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }
  checkEdit() {
    if (this.editItem) {
      if (this.editItem.idCreate) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }
  getLocation() {
    this.locationService.listActiveLocation().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listLocation = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }
  getSubtipoExame() {
    this.specificationService.listSubTypeExamByTypeExam(this.form.get("examType")!.value).subscribe({
      next: (response: ResponseRequestModel) => {
        // @ts-ignore
        this.listSubtipoExames = response.data.map((item: any) => ({
          id: Number(item.id),
          descricao: item.nome,
        }));
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }
  getDocs() {
    this.doctorService.listDoctors().subscribe({
      next: (response: ResponseRequestModel) => {
        this.doctorsList = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getAlertas() {
    this.supplierService.listEquipmentsByTypeExam(this.form.get("alert")!.value).subscribe({
      next: (response: ResponseRequestModel) => {
        this.listAlertas = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTipoExame() {
    this.examTypeService.listExamType().subscribe({
      next: (response: ResponseRequestModel) => {
        // @ts-ignore
        this.listTipoExames = response.data.map(item => ({
            ...item,
            id: Number(item.id)
          })
        )
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getContextos() {
    this.contextService.listContext().subscribe({
      next: (response: ResponseRequestModel) => {
        if(response.data) {
          this.listContextos = response.data
        }
      }, error: (err: ResponseRequestModel) => {
        console.error(err)
      }, complete: () => {
        if (this.edit) {
          this.fillForm(this.item)
        }
      },

    })
  }

  onSelectionChangeServiceSpecification(event: MatSelectChange) {
    this.form.get('parameterMin')!.setValue('')
    this.form.get('parameterMax')!.setValue('')
    this.form.get('parameterMin')!.clearValidators()
    this.form.get('parameterMax')!.clearValidators()
    this.form.get('parameterMin')!.enable()
    this.form.get('parameterMax')!.enable()
    if (event.value >= 0) {
      this.getServiceSpecification(event.value)
    }
  }

  getServiceSpecification(idType: number, idService: number = -1) {
    this.listServiceSpecification = []
    this.serviceSpecificationService
      .listServiceSpecificationByType(idType)
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.listServiceSpecification = response.data ?? []
          if (idService >= 0) {
            this.checkService(
              this.listServiceSpecification.find((ele) => {
                return ele.id == idService
              }),
            )
          }
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
  }
  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm(this.item)
    }
  }
  addTariff() {
    this.loading = true
    const model = this.createModel()
    this.responseInsert.emit(model)
    console.log('model exam', model)
    this.loading = false
    this.close()
  }

  editTariff() {
    this.loading = true
    const model = this.createModel()
    this.responseInsert.emit(model)
    this.tariffService.createTariff(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseInsert.emit(true)
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  checkForm() {
    const usarParametros = this.form.get('parameterPattern')?.value;

    if (this.form.valid) {
      // Se usar parâmetros personalizados, verifica se tem pelo menos um parâmetro
      if (usarParametros && this.parametros.length === 0) {
        return false;
      }
      return true;
    } else {
      return false;
    }
  }

  close() {
    this.dialogRef.close()
  }

  getDescription(id: number, list: any[]) {
    console.log("id tentado: "+id, "lista: "+list.length)
    if(list == this.doctorsList){
      let index = list.findIndex((ele) => {
        return ele.id == id
      })
      return index > -1 ? list[index].nome_principal : ''
    }
    if(list == this.listContextos){
      let index = list.findIndex((ele) => {
        console.log(ele, id)
        return ele.id == id
      })
      if(index === undefined || index === null) {
        index = list.findIndex((ele) => {
          console.log(ele.contexto_id, id)
        return ele.contexto_id == id
      }) }
      console.log("achou o contexto: "+list[index].nome, "id: "+index)
      return index > -1 ? list[index].nome : ''
    }
    if(list == this.listUnidadesMedida){
      let index = list.findIndex((ele) => {
        return ele.id == id
      })
      return index > -1 ? list[index].tipo_unidade : ''
    }
    let index = list.findIndex((ele) => {
      return ele.id == id
    })
    return index > -1 ? list[index].descricao : ''
  }
  getListItems() {
    this.loading = true
    this.taxDocumentTypeService
      .listPagedTaxDocumentType()
      .subscribe({
        next: (response: any) => {
          this.listUnidadesMedida = response.data
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }
  createModel() {
    const usarParametrosPersonalizados = this.form.get('parameterPattern')!.value;

    let modelBase: any = {
      tipo_exame_id: this.form.get('examType')!.value,
      exame: this.getDescription(
        this.form.get('examSubType')!.value,
        this.listSubtipoExames,
      ),
      descricaoExame: this.form.get('descricao')!.value,
      equipamento_id: this.form.get('alert')!.value,
      tutorlocal_associado_id: this.form.get('idMedico')!.value,
      subtipo_exame: this.form.get('examSubType')!.value,
    };

    // Se usar parâmetros personalizados, sempre usa formato de array
    if (usarParametrosPersonalizados && this.parametros.length > 0) {
      modelBase.usar_parametros_personalizados = true;
      modelBase.parametros = this.parametros; // Sempre array, nunca formato simplificado
    }

    if (this.edit) {
      return {
        idCreate: this.item.idCreate,
        ...modelBase
      };
    } else {
      return modelBase;
    }
  }


  createForm(): void {
    this.form = this.formBuilder.group({
      alert: [null],
      examType: [null, [Validators.required]],
      examSubType: [{value: null, disabled: true}, [Validators.required]],
      descricao: [{value: "", disabled: false}, [Validators.required]],
      parameterPattern: [false],
      idMedico: [null],
    })
  }

  createFormParametro(): void {
    this.formParametro = this.formBuilder.group({
      contexto: [null, [Validators.required]],
      parametro_minimo: ['', [Validators.required]],
      parametro_maximo: ['', [Validators.required]],
      tipo_unidade: [null, [Validators.required]],
    })
  }

  addParametro() {
    if (this.formParametro.valid) {
      const parametro = {
        contexto_id: this.formParametro.get('contexto')!.value,
        parametro_minimo: this.formParametro.get('parametro_minimo')!.value,
        parametro_maximo: this.formParametro.get('parametro_maximo')!.value,
        tipo_unidade: this.formParametro.get('tipo_unidade')!.value,
        contextoDescricao: this.getDescription(this.formParametro.get('contexto')!.value, this.listContextos),
        tipoUnidadeDescricao: this.getDescription(this.formParametro.get('tipo_unidade')!.value, this.listUnidadesMedida),
      };

      if (this.editingParametroIndex >= 0) {
        // Editando parâmetro existente
        this.parametros[this.editingParametroIndex] = parametro;
        this.editingParametroIndex = -1;
      } else {
        // Adicionando novo parâmetro
        this.parametros.push(parametro);
      }

      this.formParametro.reset();
      this.snackbar.success('Parâmetro adicionado com sucesso!');
    }
  }

  editParametro(index: number) {
    const parametro = this.parametros[index];
    this.formParametro.patchValue({
      contexto: parametro.contexto_id,
      parametro_minimo: parametro.parametro_minimo,
      parametro_maximo: parametro.parametro_maximo,
      tipo_unidade: parametro.tipo_unidade,
    });
    this.editingParametroIndex = index;
  }

  removeParametro(index: number) {
    this.parametros.splice(index, 1);
    this.snackbar.success('Parâmetro removido!');
  }

  cancelEditParametro() {
    this.formParametro.reset();
    this.editingParametroIndex = -1;
  }

  fillForm(item: any, alterTab: boolean = false) {
    if (item) {
      this.form.get('idMedico')!.setValue(item.tutorlocal_associado_id)
      this.getServiceSpecification(item.tipoServicoId, item.servicoId)

      this.supplierSelected = {
        id: item.fornecedorId,
        descricao: item.fornecedor ?? '',
      }

      this.form.get('alert')!.setValue(item.equipamento_id)
      this.form.get('examType')!.setValue(item.tipo_exame_id)
      this.form.get('examSubType')!.setValue(item.subtipo_exame)
      this.form.get('descricao')!.setValue(item.descricaoExame)
      this.form.get('examSubType')!.enable()
      // Verifica se tem parâmetros personalizados
      if (item.usar_parametros_personalizados) {
        this.form.get('parameterPattern')!.setValue(true)

        if (item.parametros && item.parametros.length > 0) {
          // Array de parâmetros
          this.parametros = item.parametros.map((p: any) => ({
            ...p,
            contextoDescricao: this.getDescription(p.contexto_id, this.listContextos),
            tipoUnidadeDescricao: this.getDescription(p.tipo_unidade, this.listUnidadesMedida),
          }));
        } else if (item.parametro_minimo !== undefined) {
          // Formato simplificado
          this.parametros = [{
            contexto_id: item.contexto_id,
            parametro_minimo: item.parametro_minimo,
            parametro_maximo: item.parametro_maximo,
            tipo_unidade: item.tipo_unidade,
            contextoDescricao: this.getDescription(item.contexto_id, this.listContextos),
            tipoUnidadeDescricao: this.getDescription(item.tipo_unidade, this.listUnidadesMedida),
          }];
        }
      } else {
        this.form.get('parameterPattern')!.setValue(false)
      }

      if (this.tabGroup && alterTab) {
        this.tabGroup.selectedIndex = 0
      }
    }
  }

  onSelectionChangeService(event: MatSelectChange) {
    this.form.get('driverType')!.setValue('')
    this.form.get('vehicleType')!.setValue('')
    let specificationService = this.listServiceSpecification.find((ele) => {
      return ele.id == event.value
    })
    this.checkService(specificationService)
  }

  checkService(specificationService?: any) {
    // Método mantido para compatibilidade
  }

  addSupplier() {
    const dialogRef = this.dialog.open(ModalSupplierComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.supplierSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          this.supplierSelected = response.selection
          this.form
            .get('supplier')!
            .setValue(this.supplierSelected.nomeFantasia)
        } else {
          this.supplierSelected = {}
          this.form.get('supplier')!.setValue('')
        }
      }
    })
  }

  openDatepicker() {
    this.datepicker()?.open()
  }

  selectItem(item: any) {
    this.fillForm(this.item)
  }

  getUnidadeDescricao(id: number): string {
    const unidade = this.listUnidadesMedida.find(u => u.id === id);
    return unidade ? unidade.tipo_unidade : '';
  }
}
